import React, { Fragment, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Box from '@mui/material/Box';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { ToastContainer, toast } from 'react-toastify';

import '../modals.css';

const AddNewGroup = ( { close, aid, uid, lists, cl } ) => {
    const [ search, setSearch ] = useState( '' );
    const [ unique, setUnique ] = useState( false );
    const [ names, setNames ] = useState( [] );
    const [ listType, setListType ] = useState( 'contacts' );
    const listTypes = [
        { label: 'Contacts', value: 'contacts' },
        { label: 'Loans', value: 'loans' }
    ];

    const filterGroup = ( e ) => {
        setSearch( e.target.value );
    };

    const create = async () => {
        const resp = await cl( { 
            aid: aid, 
            uid: uid, 
            name: search, 
            items: [],
            itemType: listType,
        } );
        console.log( resp );
        toast.success( search + ' successfully created!', { theme: 'dark' } );
        close();
    }

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '450px',
        bgcolor: 'background.paper',
        border: '1px solid #000',
        p: 2,
        maxHeight: '95vh',
        overflowY: 'auto'
    };

    useEffect( () => {
        if ( lists ) {
            const labels = [];
            Object.keys( lists ).forEach( ( gid ) => {
                const l = lists[gid];
                labels.push( l.label.toLowerCase() );
            } );
            setNames( labels );
        }
    }, [ lists ] );

    useEffect( () => {
        if ( !search || search === '' ) {
            setUnique( false );
        } else {
            const found = names.find( f => f === search.toLowerCase() );
            if ( found ) {
                setUnique( false );
            } else {
                setUnique( true );
            }
        }
    }, [ search, names ] );

    return (
        <Fragment>
            <Box sx={ { ...style, pt: 0 } }>
                <Row className='py-2' style={ { borderBottom: '1px solid var( --bs-border-color )' } }>
                    <Col className='tf-modal-title'>Create a New List</Col>
                </Row>
                <Row className='py-3'>
                    <Form.Group>
                        <Form.Label>Is the list for contacts or loans?</Form.Label>
                        <Form.Select size='sm' className='tf-modal-text-input' value={listType} onChange={ ( e ) => setListType( e.target.value ) }>
                        {
                            listTypes.map( ( lt, idx ) => <option key={`${lt.value}-${idx}`} value={lt.value}>{lt.label}</option>)
                        }
                        </Form.Select>
                    </Form.Group>
                </Row>
                <Row className='py-3'>
                    <Col><Form.Control className='tf-modal-text-input' type="text" placeholder="Type a name for the list..." value={search} onChange={filterGroup} /></Col>
                    { unique ? (
                        <Col xs='auto'>
                            <Button size='sm' variant='outline-primary' onClick={ () => create() }>Create</Button>
                        </Col>
                    ) : (
                        <Fragment />
                    ) }
                </Row>
            </Box>
            <ToastContainer autoClose={3000} />
        </Fragment>
    )
}

const mapProps = ( state ) => ( {
    // aid: state.user.aid,
    uid: state.user.email,
    lists: state.lists.byId,
} );
  
const mapDispatch = ( dispatch ) => ( {
    cl: dispatch.lists.createList
} );
  
export default connect( mapProps, mapDispatch )( AddNewGroup );